export default {
    allStatus: 'สถานะทั้งหมด',
    searchByEmployeeNoOrName: 'ค้นหาโดยรหัสพนักงานหรือชื่อ',
    statusAttendance: 'สถานะเข้างาน',
    absent: 'ขาด',
    leaveFullday: 'ลาครึ่งวัน',
    leaveHalfday: 'ลาทั้งวัน',
    present: 'ตรงเวลา',
    late: 'สาย',
    onsiteFullday: 'ทำงานนอกสถานที่เต็มวัน',
    onsiteHalfday: 'ทำงานนอกสถานที่ครึ่งวัน',
    search: 'ค้นหา',
    employeeNo: 'รหัสพนักงาน',
    name: 'ชื่อ - นามสกุล',
    startDate: 'วันเริ่มต้น',
    endDate: 'วันสิ้นสุด',
    date: 'วันที่',
    status: 'สถานะ',
    ciType: 'เข้างานโดย',
    ciTime: 'เวลาเข้า',
    coType: 'ออกงานโดย',
    coTime: 'เวลาออก',
    terminalIn: 'สถานที่ (เข้า)',
    terminalOut: 'สถานที่ (ออก)',
    totalHours: 'จำนวนชั่วโมง',
    note: 'หมายเหตุ: ระบบ Olaf จะคำนวณจำนวนชั่วโมงโดยอ้างอิงจากการลงเวลาครั้งแรกถึงลงเวลาครั้งสุดท้าย'
}
